import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage, PlanPage, SettingsPage, LoginPage, DomainSelectionPage } from './pages';
import APInvoiceDashboardPage from './pages/APInvoiceDashboardPage';
import ExceptionWorkspacePage from './pages/ExceptionWorkspacePage';
import VASCommandCenterPage from './pages/VASCommandCenterPage';
import SupplyChainCommandCenterPage from './pages/SupplyChainCommandCenterPage';
import CaseDetailPage from './pages/CaseDetailPage';
import { useWebSocket } from './hooks/useWebSocket';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Protected route wrapper
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

function AppRoutes() {
  const { isConnected, isConnecting, error } = useWebSocket();

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/domains" element={<ProtectedRoute><DomainSelectionPage /></ProtectedRoute>} />
      <Route path="/workspace" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
      <Route path="/plan/:planId" element={<ProtectedRoute><PlanPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/ap-invoice-dashboard" element={<ProtectedRoute><APInvoiceDashboardPage /></ProtectedRoute>} />
      <Route path="/exceptions" element={<ProtectedRoute><ExceptionWorkspacePage /></ProtectedRoute>} />
      <Route path="/exceptions/:caseId" element={<ProtectedRoute><CaseDetailPage /></ProtectedRoute>} />
      <Route path="/domains/vas" element={<ProtectedRoute><VASCommandCenterPage /></ProtectedRoute>} />
      <Route path="/domains/supply-chain" element={<ProtectedRoute><SupplyChainCommandCenterPage /></ProtectedRoute>} />
      {/* Redirect root to domains page after login */}
      <Route path="/" element={<ProtectedRoute><Navigate to="/domains" replace /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/domains" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;